var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-base-piscine',{ref:"baseEdit",attrs:{"title":"Template de cours","width":"900"}},_vm._l((_vm.activitesCours),function(tc){return _c('edit-template-cours-item',{key:tc.acyId,attrs:{"tc":tc,"piscine":_vm.piscine}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }